import React from 'react'
import styled, { css } from 'styled-components'
import Typography, { TYPOGRAPHY_ICON_SIZE_CSS_VAR, TYPOGRAPHY_LINE_HEIGHT_CSS_VAR } from './Typography'
import cn from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { setCSSVar } from 'lib/theme/themeUtils'

export const Subtitle1Style = css`
  ${setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, '22px')}
  ${setCSSVar(TYPOGRAPHY_ICON_SIZE_CSS_VAR, rem(24))}
  font-size: 18px;

  ${mediaQueryUp.tablet} {
    ${setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, '24px')}
    font-size: 20px;
  }
`

export const Subtitle2Style = css`
  ${setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, '20px')}
  ${setCSSVar(TYPOGRAPHY_ICON_SIZE_CSS_VAR, rem(20))}
  font-size: 16px;

  ${mediaQueryUp.tablet} {
    ${setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, '22px')}
    font-size: 18px;
  }
`

export const Subtitle3Style = css`
  ${setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, '18px')}
  ${setCSSVar(TYPOGRAPHY_ICON_SIZE_CSS_VAR, rem(20))}
  font-size: 14px;

  ${mediaQueryUp.tablet} {
    ${setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, '20px')}
    font-size: 16px;
  }
`

/*
  Font sizes are express in px as they are not to be affected by the
  20% REM font decrease at mobile sizes. These font sizes are absolute sizes.
*/
const Element = styled(Typography)`
  ${setCSSVar(TYPOGRAPHY_LINE_HEIGHT_CSS_VAR, '1.5')}
  font-family: ${props => props.theme.font.secondary.family};

  /* reset font-style */
  &, &:is(i, em), i, em {
    font-style: normal;
  }

  &, &:is(b, strong), b, strong {
    font-weight: ${props => props.theme.font.secondary.weight.regular};
  }

  &.variant-subtitle1 {
    ${Subtitle1Style}
  }

  &.variant-subtitle2 {
    ${Subtitle2Style}
  }

  &.variant-subtitle3 {
    ${Subtitle3Style}
  }
`

interface Props extends Omit<React.ComponentProps<typeof Typography>, 'forwardedAs'> {
  variant: 'subtitle1' | 'subtitle2' | 'subtitle3';
}

function Subtitle(props: Props) {
  const {
    variant,
    as,
    className,
    ...rest
  } = props

  return <Element
    {...rest}
    forwardedAs={as}
    className={cn(className, `variant-${variant}`)}
  />
}

export default Subtitle
